'use client'
import Script from "next/script"

const BreadcrumbsNewDevelopmentsLdJson = ({ project }) => {

    let jsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `${process.env.NEXT_PUBLIC_SHARE_URL}`
        },{
          "@type": "ListItem",
          "position": 2,
          "name": "Pattaya New Development Projects",
          "item": `${process.env.NEXT_PUBLIC_SHARE_URL}/new-developments`
        },{
          "@type": "ListItem",
          "position": 3,
          "name": `${project.name}`,
          "item": `${process.env.NEXT_PUBLIC_SHARE_URL}/new-developments/${project.slug}`
        }]
      }
  
    return (
        <Script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
            key="breadcrumb-jsonld"
        />
    )
}

export default BreadcrumbsNewDevelopmentsLdJson